import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
  }

  remove() {
    // Remove the entire controller element from the DOM
    this.element.remove()
  }
}
